import Axios from 'axios';

export const client = Axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});